<template>
  <div class="row">
    <div class="col-lg-3">
      <div class="col-lg-9">
        <v-select placeholder="Status" :options="activeStatus" index="id" label="label" v-model="filters['status']" @input="filterUsers"></v-select>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { Query } from '../../../../mixins/helperMixin'

export default {
  data () {
    return {
      filters: {},
      activeStatus: [
        {label: 'Active', id: 'active'},
        {label: 'Not active', id: 'not-active'},
        {label: 'Blacklisted', id: 'blacklisted'}
      ]
    }
  },
  mixins: [Query],
  computed: {
    ...mapGetters({
      f: 'getFilters',
      brands: 'getBrands'
    })
  },
  mounted () {
    this.$store.dispatch('loadBrands', this.buildQuery(this.filters))
  },
  methods: {
    filterUsers () {
      this.$store.dispatch('loadBrands', this.buildQuery(this.filters))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Advertisers/Brands/Filters.vue